export const StarDash = ({ className = "", color }) => (
  <div
    className={`star-dash ${className}`}
    style={color ? { color } : undefined}
    aria-hidden="true"
  >
    <span className="seg" />
    <span className="star">★</span>
    <span className="seg" />
    <span className="star">★</span>
    <span className="seg" />
    <span className="star">★</span>
    <span className="seg" />
  </div>
);
